// Generated by Melange

import CoverArtModuleCss from "./coverArt.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Js__Js_nullable from "melange.js/js_nullable.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Store__Context from "../store/context.jsx";
import * as Subsonic__CoverArt from "../api/subsonic/coverArt.jsx";
import Clsx from "clsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = CoverArtModuleCss;

function createSrcSet(credentials, coverArt) {
  return [
    50,
    100,
    200,
    300,
    400,
    500,
    750,
    1000,
    1250,
    1500,
    2000
  ].map(function (size) {
    return Subsonic__CoverArt.makeUrl(credentials, coverArt, size, undefined) + (" " + (String(size) + "w"));
  }).join(",");
}

function preload(credentials, coverArt, sizes) {
  const img = new Image();
  img.sizes = sizes;
  img.srcset = createSrcSet(credentials, coverArt);
}

function CoverArt(Props) {
  let alt = Props.alt;
  let className = Props.className;
  let coverArt = Props.coverArt;
  let _lazy = Props.lazy;
  let sizes = Props.sizes;
  const credentials = Store__Context.useAppStore(function (state) {
    return state.auth.credentials;
  });
  const srcSet = React.useMemo((function () {
    if (coverArt !== undefined && credentials !== undefined) {
      return createSrcSet(credentials, coverArt);
    }
    
  }), [
    coverArt,
    credentials
  ]);
  const match = React.useState(function () {
    return false;
  });
  const setIsLoaded = match[1];
  const match$1 = React.useState(function () {
    
  });
  const setLastLoadedSrc = match$1[1];
  const imgRef = React.useRef(null);
  React.useEffect((function () {
    Curry._1(setIsLoaded, (function (param) {
      return false;
    }));
    Curry._1(setLastLoadedSrc, (function (param) {
      
    }));
  }), [srcSet]);
  React.useEffect((function () {
    Js__Js_nullable.bind((function (v) {
      Curry._1(setLastLoadedSrc, (function (param) {
        const x = v.currentSrc;
        return Caml_option.nullable_to_opt(Js__Js_nullable.bind((function (v) {
          if (v === "") {
            return;
          } else {
            return v;
          }
        }), x));
      }));
      Curry._1(setIsLoaded, (function (param) {
        return v.complete;
      }));
      return null;
    }), imgRef.current);
  }), []);
  let tmp = {
    ref: imgRef,
    className: Clsx(css.img, !match[0] || Stdlib__Option.is_none(srcSet) ? css.img_not_loaded : undefined),
    onError: (function ($$event) {
      Curry._1(setIsLoaded, (function (param) {
        return false;
      }));
      const img = $$event.currentTarget;
      setTimeout((function (param) {
        Object.assign(img, {
          src: img.currentSrc
        });
      }), 3000);
    }),
    onLoad: (function ($$event) {
      const currentSrc = $$event.currentTarget.currentSrc;
      const complete = $$event.currentTarget.complete;
      Curry._1(setLastLoadedSrc, (function (param) {
        return currentSrc;
      }));
      Curry._1(setIsLoaded, (function (param) {
        return complete;
      }));
    })
  };
  if (alt !== undefined) {
    tmp.alt = Caml_option.valFromOption(alt);
  }
  if (sizes !== undefined) {
    tmp.sizes = Caml_option.valFromOption(sizes);
  }
  const tmp$1 = match$1[0];
  if (tmp$1 !== undefined) {
    tmp.src = Caml_option.valFromOption(tmp$1);
  }
  if (srcSet !== undefined) {
    tmp.srcSet = Caml_option.valFromOption(srcSet);
  }
  return JsxRuntime.jsx("div", {
    children: React.cloneElement(JsxRuntime.jsx("img", tmp), {
      decoding: Stdlib__Option.bind(_lazy, (function (b) {
        if (b) {
          return "async";
        }
        
      })),
      loading: Stdlib__Option.bind(_lazy, (function (b) {
        if (b) {
          return "lazy";
        }
        
      }))
    }),
    className: Clsx(className, css.root)
  });
}

const make = CoverArt;

export {
  createSrcSet,
  preload,
  make,
}
/* css Not a pure module */
